import React, { useEffect, useState } from 'react';
import { MemoryRouter } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import { ThemeProvider } from '../shared/providers/ThemeProvider';
import { ErrorBoundary } from '../shared/components/ErrorBoundary';
import { BottomNav } from '../shared/components/BottomNav';
import { Toaster } from '../shared/components/Toast';
import { SplashScreen } from '../shared/components/SplashScreen';
import { AppRoutes } from './routes';
import { useAppStore } from '../shared/store';
import { OnboardingFlow } from '../domains/onboarding/OnboardingFlow';
import { seedStores, seedInventory, createDemoDeals, seedShoppingList, seedTransactions } from '../shared/data/seedData';
function SeedOnFirstLoad() {
  const seeded = useAppStore(s => s.seeded);
  const setSeeded = useAppStore(s => s.setSeeded);
  const setInventory = useAppStore(s => s.setInventory);
  const setShoppingList = useAppStore(s => s.setShoppingList);
  const setActiveDeals = useAppStore(s => s.setActiveDeals);
  const setTransactions = useAppStore(s => s.setTransactions);
  const setStores = useAppStore(s => s.setStores);
  const stores = useAppStore(s => s.stores);
  const inventory = useAppStore(s => s.inventory);
  const settings = useAppStore(s => s.settings);
  const updateSettings = useAppStore(s => s.updateSettings);
  const activeDeals = useAppStore(s => s.activeDeals);
  const onboardingCompleted = settings.onboardingCompleted;
  const hasPersonalSetup = stores.length > 0 || inventory.length > 0;
  useEffect(() => {
    if (!onboardingCompleted) return;
    if (!seeded) {
      if (hasPersonalSetup) {
        if (activeDeals.length === 0) {
          setActiveDeals(createDemoDeals(stores));
        }
      } else {
        setStores(seedStores);
        setInventory(seedInventory);
        setActiveDeals(createDemoDeals(seedStores));
        setShoppingList(seedShoppingList);
        setTransactions(seedTransactions);
      }
      setSeeded(true);
      updateSettings({
        demoDealsVersion: 1
      });
      return;
    }

    // One-time repair for people who completed onboarding before demo deals were loaded.
    if (settings.demoDealsVersion !== 1) {
      if (activeDeals.length === 0) {
        setActiveDeals(createDemoDeals(stores));
      }
      updateSettings({
        demoDealsVersion: 1
      });
    }
  }, [activeDeals.length, hasPersonalSetup, onboardingCompleted, seeded, setActiveDeals, setInventory, setSeeded, setShoppingList, setStores, setTransactions, settings.demoDealsVersion, stores, updateSettings]);
  return null;
}
export function App() {
  const [showSplash, setShowSplash] = useState(true);
  const onboardingCompleted = useAppStore(s => s.settings.onboardingCompleted);
  const seeded = useAppStore(s => s.seeded);
  // Existing users who already seeded should skip onboarding
  const shouldShowOnboarding = !onboardingCompleted && !seeded;
  useEffect(() => {
    const timer = setTimeout(() => {
      setShowSplash(false);
    }, 2500);
    return () => clearTimeout(timer);
  }, []);
  return <ErrorBoundary data-id="element-17" data-mp="il47ur0qxnma">
      <ThemeProvider defaultTheme="light" data-id="element-18" data-mp="ijjdp2icg6oy">
        <MemoryRouter data-id="element-19" data-mp="3vy9t6dna3fz">
          <SeedOnFirstLoad data-id="element-20" data-mp="3whtariy0zw4" />
          <AnimatePresence data-id="element-21" data-mp="3v6pwstetu5j">{showSplash && <SplashScreen data-id="element-22" data-mp="3tvimj0ra49o" />}</AnimatePresence>

          {!showSplash && shouldShowOnboarding ? <OnboardingFlow data-id="element-23" data-mp="8syizq5sjmbb" /> : <div className="min-h-screen bg-background text-foreground pb-20 font-sans selection:bg-primary/30" data-id="element-24" data-mp="3r0eemcfkzh0e">
              <AppRoutes data-id="element-25" data-mp="3w0imje2fb3f0" />
              <BottomNav data-id="element-26" data-mp="3w122ip8ijhqe" />
            </div>}

          <Toaster data-id="element-27" data-mp="3h39sudpndnk4" />
        </MemoryRouter>
      </ThemeProvider>
    </ErrorBoundary>;
}